export const DEFAULT_ENCODER_CONFIG = {
  width: 848,
  height: 480,
  frameRate: 30,
  bitrate: 930,
};
